"use client";

import { ArrowPathIcon } from "@heroicons/react/24/solid";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body>
        <h2>Something went wrong!</h2>
        <button
          type="button"
          onClick={() => reset()}
          className="inline-flex items-center gap-x-1.5 rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary"
        >
          Try Again
          <ArrowPathIcon className="-mr-0.5 h-5 w-5" aria-hidden="true" />
        </button>
      </body>
    </html>
  );
}
